
export const pricing = {
  'request.pricing': 'Preisanfrage',
  'view.pricing': 'Preise anzeigen',
  'product.pricing': 'Produktpreise',
};
